import type {
	Components,
} from '@mui/material'

export const materialUIContainerTheme: {
	components: Components
} = {
	components: {
		MuiContainer: {
			styleOverrides: {
				root: {
				},
			},
		},
	},
}
